import React, { Children, useState } from "react";
import Drawer from "@mui/material/Drawer";

// import JS files
import { useUserData } from "../../context/UserDataContext";

// import Others files

const PanelDrawer = ({ children, openDrawer, setOpenDrawer, anchor }) => {
  let windowWidth = window.screen.width;
  const { userData } = useUserData();
  return (
    <>
      <Drawer
        anchor={anchor}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        {children}
      </Drawer>
    </>
  );
};

export default PanelDrawer;
